export default ($axios) => ({
  findParametros() {
    return $axios.get(`/parametros`)
  },
  getParametroById(idParametro) {
    return $axios.get(`/parametros/${idParametro}`)
  },
})
